import { useWizard } from '../wizard-context';

import type { SmartTagWizardOptions } from './types';

type ShowSmartTagWizardOptions = SmartTagWizardOptions & {
  smartTagId?: number | undefined;
};

export function useSmartTagWizard() {
  const { getWizardState, showWizard, hideWizard } = useWizard();

  const state = getWizardState('smartTag');

  return {
    smartTagId: state.entityId,
    initialState: state.initialState,
    isWizardActive: state.isActive,
    showSmartTagWizard: (options?: ShowSmartTagWizardOptions) =>
      showWizard('smartTag', { ...options, entityId: options?.smartTagId }),
    hideSmartTagWizard: () => hideWizard('smartTag'),
  };
}
